module.exports = __webpack_public_path__ + "static/img/about-banner.9c8d94e8.jpg";